import React from 'react';
import { connect } from 'react-redux';

import CreatedSegments from '../components/CreatedSegments';
import CreateSegment from '../components/CreateSegment';

class SegmentsContainer extends React.Component {
  state = {
    isCreateSegmentView: false,
    isListSegmentsView: true,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { match } = this.props;
    if (match?.path && match.path?.indexOf('new') > 0) {
      this.setState({ ...this.state, isCreateSegmentView: true, isListSegmentsView: false });
    } else {
      this.setState({ ...this.state, isCreateSegmentView: false, isListSegmentsView: true });
    }
  }

  render() {
    if (this.state.isCreateSegmentView) {
      return <CreateSegment />;
    } else {
      return <CreatedSegments segmentList={this.props.nudge.segmentList} />;
    }
  }
}

const mapStateToProps = state => ({
  nudge: { ...state.nudge },
  breadCrumbs: { ...state.breadCrumbs },
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SegmentsContainer);
